import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/reviews")({
  component: lazyRouteComponent(() => import("./-pages/admin.reviews")),
});
